import { render, staticRenderFns } from "./GroupResultsModalFooter.vue?vue&type=template&id=b3dfcc9a"
import script from "./GroupResultsModalFooter.vue?vue&type=script&lang=ts"
export * from "./GroupResultsModalFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports